import { PersonIcon } from "@/app/design-system/icons/components/person-icon";

import { NavigationMenuItem } from "../../components.utility/navigation-menu-item";

interface MyProfileMenuItemProps {
  isCollapsed: boolean;
}

export function MyProfileMenuItem({ isCollapsed }: MyProfileMenuItemProps) {
  const menuItemName = "My Profile";
  return (
    <NavigationMenuItem
      to="/profile"
      menuItemTooltipContent={menuItemName}
      isCollapsed={isCollapsed}
    >
      <PersonIcon
        height={20}
        width={20}
        aria-hidden={!isCollapsed}
        title={!isCollapsed ? "" : menuItemName}
      />
      {!isCollapsed ? menuItemName : null}
    </NavigationMenuItem>
  );
} 